import { connect } from "react-redux";
import { GetBadDebtsReportApi } from "./Report.action";
import { Link } from "react-router-dom";
import { CalendarIcon, DownloadIcon, ChevronRightIcon } from "../../../components/Icons";
// import _ from "lodash";
import Swal from "sweetalert";
import SinglePageDashboard from "../../../drawer/SinglePageDashbord";
import GlobalFormCard from "../../../components/GlobalFormCard";
import "./Report.css";


const BadDebtsReport = (props) => {
    const isDisabled = props.isFetchingBadDebtsReport;
    const handleDangerVisible = () => {
        Swal({
            title: "Error",
            text: "Something went wrong!",
            icon: "error",
            button: "Ok",
        });
    };

    const GenratePDF = () => {
        props.GetBadDebtsReportApi(handleDangerVisible);
    };

    return (
        <>
            <SinglePageDashboard header="Bad Debts Report" />

            <div className="page-container">
                <div className="breadcrumb">
                    <Link to="/home" className="breadcrumb-link">Home</Link>
                    <ChevronRightIcon />
                    <Link to="/report" className="breadcrumb-link">Reports</Link>
                    <ChevronRightIcon />
                    <span className="breadcrumb-current">Bad Debts Report</span>
                </div>

                <div className="page-header">
                    <h1 className="page-title">Bad Debts Report</h1>
                </div>

                <GlobalFormCard
                    title="Generate Report"
                    subtitle="Report will be generated based on the outstanding receivables data."
                    icon={<CalendarIcon />}
                    maxWidth="900px"
                >

                    <div className="divider" />

                    <button
                        onClick={GenratePDF}
                        disabled={isDisabled}
                        className={`generate-btn ${isDisabled ? "disabled" : ""}`}
                    >
                        {props.isFetchingBadDebtsReport ? (
                            <>
                                <span className="spinner" />
                                Generating…
                            </>
                        ) : (
                            <>
                                <DownloadIcon />
                                Generate Report
                            </>
                        )}
                    </button>

                    <p className="footer-text">
                        Report will be downloaded as a PDF file
                    </p>

                </GlobalFormCard>
            </div>
        </>
    );
};

const mapDispatchToProps = (dispatch) => ({
    GetBadDebtsReportApi: (handleDangerVisible) => dispatch(GetBadDebtsReportApi(handleDangerVisible)),
});

const mapStateToProps = (state) => ({
    isFetchingBadDebtsReport: state.ReportReducer.isFetchingBadDebtsReport,
    badDebtsReportData: state.ReportReducer.badDebtsReportData,
});

export default connect(mapStateToProps, mapDispatchToProps)(BadDebtsReport);